import { useSearchParams } from "react-router-dom";

import { Container } from "@mui/material";

import Page from "@/components/Page";
import { Button } from "@/components/ui/button";

export default function OrgAccessDenied() {
  const [searchParams] = useSearchParams();
  return (
    <Page title="Organization Access Denied">
      <Container
        maxWidth="lg"
        className="flex flex-col gap-4 items-center my-4"
      >
        <h1 className="text-2xl font-space-grotesk font-bold">
          You don't have access to view this organization
        </h1>
        <p>
          Go to your account settings to check and accept any pending
          organization invites
        </p>
        <a href="/app/account?tab=invites">
          <Button>Organization Invites</Button>
        </a>
        <code className="text-sm">
          Organization ID: {searchParams.get("oid")}
        </code>
      </Container>
    </Page>
  );
}
